import React from "react";
import classNames from "classnames";

import styles from "./searchNoContent.module.scss";

type SearchNoContentProps = {
    className?: string;
};

const SearchNoContent = ({ className = "" }: SearchNoContentProps) => (
    <div
        data-component="SearchNoContent"
        className={classNames(styles.me, {
            [className]: className,
        })}
        data-testid="searchNoContent"
    >
        <p>Aucun document ne correspond aux termes de recherche spécifiés.</p>

        <p>Suggestions :</p>

        <ul>
            <li>Vérifiez l’orthographe des termes de recherche.</li>
            <li>Essayez d&#39;autres mots.</li>
            <li>Utilisez des mots clés plus généraux</li>
        </ul>
    </div>
);

export default SearchNoContent;
